import React from 'react';

import cn from 'classnames';

import cls from './Chip.module.css';

interface ChipProps {
    textContent: string;
    onClick?: () => void;
    color?: string;
    containerStyles?: string;
    textStyles?: string;
    startIcon?: React.ReactNode;
    endIcon?: React.ReactNode;
}
export const Chip = ({
    textContent,
    onClick,
    color,
    containerStyles,
    textStyles,
    startIcon,
    endIcon,
}: ChipProps) => (
    <span className={cn(cls.Chip, color, containerStyles)} onClick={onClick && onClick}>
        {startIcon && startIcon}
        <span className={cn(cls.ChipText, textStyles)}>{textContent}</span>
        {endIcon && endIcon}
    </span>
);
